var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { class: { _selected: _setup.isBooked() } },
    [
      _vm._t(
        "default",
        function () {
          return [_vm._v("RoomSelector")]
        },
        { detail_click: _setup.detail_click }
      ),
      _vm._v(" "),
      _c(_setup.RoomModal, {
        attrs: {
          Cabin: _setup.props.Cabin,
          CabinSet: _setup.props.CabinSet,
          modalShown: _setup.isModalShown,
        },
        on: { input: _setup.set_isModalShown },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }